import React from 'react';
import { useModal } from './useModal';

export const ModalRoot: React.FC = () => {
  const { component: Component, props, hideModal } = useModal();

  return (
    <>
      {Component ? (
        <Component
          {...props}
          onRequestClose={props.onRequestClose || hideModal}
        />
      ) : null}
    </>
  );
};
